import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loader from "../../UI/loader";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { formatLocalTime, getDefaultAnalyticsLabel, toBool } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { DayPicker } from "react-day-picker";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { popupOpenClose } from "../../../action/action";
import { scrollToTop } from "../../../JS/scrollToTop";


const ResReservationV2_Update = (props) => {

    const { t } = props;
    const [guestComment, setGuestComment] = useState(props.selectedMyReservationData.client_requests)

    const handleBack = () => {
        props.goBack();
    }

    const handleNext = () => {
        props.proceedUpdateReservation({ reservationId: props.selectedMyReservationData.id, guestComment: guestComment })
    }
    
    const renderTimeAsPerDuration = (real_datetime, duration) => {
        const startTime = new Date(real_datetime);
        const durationMillis = duration * 60000;
        const endTime = new Date(startTime.getTime() + durationMillis);

        //format time
        const startTimeFormated = formatLocalTime(startTime, toBool(props.timeFormat));
        const endTimeFormated = formatLocalTime(endTime, toBool(props.timeFormat));

        return `${startTimeFormated} - ${endTimeFormated}`;
    }

    return (
        <section class="widgets spa-listing spa-details">

            <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{t(`resReservationV2.heading_update_reservation`)}</div>
                <div>{props.selectedMyReservationData.name}</div>
            </div>

            <div class="widgets">
                <div class="row margin-bottom-2">
                    <div class="row">
                        <div class="col">

                            <div class="detail-body stay-body">
                                <form>

                                    <div class="form-row">
                                        <p class="heading">{t('resReservationV2.reservation_date')} </p>
                                        <input type="button" disabled value={dateFormatHandler(props.selectedMyReservationData.date, props.dateFormat)} />
                                    </div>

                                    <div class="form-row">
                                        <p class="heading">{t('resReservationV2.time_slot')} </p>
                                        <input type="text" disabled name="upgrade" value={formatLocalTime(new Date(props.selectedMyReservationData.real_datetime_of_slot), toBool(props.timeFormat))} />
                                    </div>

                                    <div class="form-row">
                                        <p class="heading">{t('resReservationV2.max_guest')}</p>
                                        <div class="qty-input">
                                            <input name="guestCount" disabled value={props.selectedMyReservationData.max_guests} />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <p class="heading">{t('resReservationV2.special_request')}</p>
                                        <textarea rows="5" value={guestComment} onChange={(e) => setGuestComment(e.target.value)} placeholder={t('resReservationV2.special_request_placeholder')}></textarea>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-controls">
                            <button onClick={handleNext}>{t('resReservationV2.update_reservation')}</button>
                            <button onClick={handleBack}>{t('resReservationV2.back')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        gmtOffset: state.store.home.serverTimeDate.gmtOffset,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    }
}

export default connect(mapStateToProps, { closeOrderPopUp, sendAnalytics, popupOpenClose })(withTranslation('translations')(ResReservationV2_Update));